import { configureStore } from "@reduxjs/toolkit";
import {
  languageReducer,
  loaderReducer,
  profileReducer,
  tabsReducer,
  permissionReducer,
  notificationReducer,
  awsReducer,
  filterDatesReducer,
} from "../Reducer/Reducer";

export const store = configureStore({
  reducer: { languageReducer, profileReducer, loaderReducer, tabsReducer, permissionReducer,notificationReducer,awsReducer,filterDatesReducer },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
